export const CHARGE_STATUS_CODES = {
  SCHEDULED: "S",
  OPEN: "O",
  CLOSED: "C",
  CHARGED_INTO_EAF: "H",
} as const;

export type ChargeStatusCode =
  (typeof CHARGE_STATUS_CODES)[keyof typeof CHARGE_STATUS_CODES];

export interface Charge {
  ChargeId?: number | null;
  HeatName?: number | null;
  RecipeChargeId?: number | null;
  ChargeGroupNumber?: number | null;
  ChargeSequenceNumber?: number | null;
  BucketId: number;
  BucketName?: string | null;
  ChargeStatusCode: ChargeStatusCode;
  RecipeId?: number | null;
  ChargeNumber?: number | null;
  RecipeName?: string | null;
  RecipeIsEnable?: boolean | null;
  CreationTimestamp?: string | null;
  OpenTimestamp?: string | null;
  CloseTimestamp?: string | null;
  UpdateTimestamp?: string | null;
  ManualTargetWeight?: number | null;
  OperatorId?: number | null;
  OperatorName?: string | null;
  Comments?: string | null;
  TotalWeight?: number;
  FluxWeight?: number;
  AimChargeWeight?: number | null;
  ScheduledHeatName?: string | null;
  HeatWeightRequestId?: number | null;
  RequestedHeatId?: number | null;
  RequestedHeatWeight?: number | null;
  HeatWeightRequestCreationTimestamp?: string | null;
  CurrentHeatName?: string | null;
  NextChargeNumber?: number | null;
  CurrentHeatUnlinked?: boolean | null;
}

export const CHARGE_INITIAL_VALUES: Charge = {
  ChargeId: null,
  BucketId: 0,
  ChargeStatusCode: CHARGE_STATUS_CODES.SCHEDULED,
  RecipeId: null,
  ChargeGroupNumber: null,
  CreationTimestamp: null,
  OpenTimestamp: null,
  CloseTimestamp: null,
  ManualTargetWeight: 0,
  OperatorId: null,
  Comments: "",
  TotalWeight: 0,
  ScheduledHeatName: null,
};
